// ---------------------------------------------------------------------------
// quODIN Assessments — frontend module registration.
//
// Three routes are registered rather than one nested router so each page can
// be deep-linked (the runner and report both read their target from the query
// string). Only the hub carries a title, so the nav shows a single entry.
// ---------------------------------------------------------------------------
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import AssessmentIcon from '@material-ui/icons/AssignmentTurnedIn';
import { AssessmentProviders } from './modern';

const hubPage = PageBlueprint.make({
  name: 'hub',
  params: {
    path: '/assessments',
    title: 'Assessments',
    icon: <AssessmentIcon />,
    loader: async () => {
      const { HubPage } = await import('./HubPage');
      return (
        <AssessmentProviders>
          <HubPage />
        </AssessmentProviders>
      );
    },
  },
});

const runnerPage = PageBlueprint.make({
  name: 'runner',
  params: {
    path: '/assessments/run',
    loader: async () => {
      const { RunnerPage } = await import('./RunnerPage');
      return (
        <AssessmentProviders>
          <RunnerPage />
        </AssessmentProviders>
      );
    },
  },
});

const reportPage = PageBlueprint.make({
  name: 'report',
  params: {
    path: '/assessments/report',
    loader: async () => {
      const { ReportPage } = await import('./ReportPage');
      return (
        <AssessmentProviders>
          <ReportPage />
        </AssessmentProviders>
      );
    },
  },
});

// A plugin, not a module: modules extend an existing plugin, whereas these
// pages introduce a new one.
export const assessmentsPlugin = createFrontendPlugin({
  pluginId: 'assessments',
  title: 'Assessments',
  icon: <AssessmentIcon />,
  extensions: [hubPage, runnerPage, reportPage],
});
